module.exports = __webpack_public_path__ + "static/img/s31.437ee2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s31.jpg
// module id = K9l6
// module chunks = 1